import { rootRoute } from './routes/__root'
import { indexRoute } from './routes/index'
import { loginRoute } from './routes/login'
import { authenticatedRoute } from './routes/_authenticated'
import { publicWithTabsRoute } from './routes/_publicWithTabs'
import { onboardingRoute } from './routes/_onboarding'
import {
  onboardingPermissionsRoute,
  onboardingProfileRoute,
  onboardingFriendsRoute,
  onboardingQuizRoute,
} from './routes/onboarding'
import { dashboardRoute, digestArchiveRoute, pastIssueRoute } from './routes/dashboard'
import { feedRoute } from './routes/feed'
import { searchRoute } from './routes/search'
import { menuRoute } from './routes/menu'
import { historyRoute } from './routes/history'
import { notificationsRoute } from './routes/notifications'
import { friendsRoute, friendsUserRoute } from './routes/friends'
import { blockedUsersRoute } from './routes/blocked-users'
import { reportsRoute } from './routes/reports'
import { settingsRoute } from './routes/settings'
import { notificationSettingsRoute } from './routes/settings/notifications'
import { subscriptionSettingsRoute } from './routes/settings/subscription'
import { appearanceSettingsRoute } from './routes/settings/appearance'
import { quizzesIndexRoute, quizRoute } from './routes/quizzes'
import { profileIndexRoute, profileEditRoute, profileUserRoute } from './routes/profile'
import { restaurantRoute } from './routes/restaurants'
import { listsIndexRoute, listDetailsRoute, collaborativeListDetailsRoute } from './routes/lists'
import { postRoute } from './routes/posts'
import { syncContactsRoute } from './routes/sync-contacts'
import { quickSearchRoute } from './routes/quick-search'

export const routeTree = rootRoute.addChildren([
  // Root index (redirects to /search)
  indexRoute,

  // Login route (public, restricted if logged in)
  loginRoute,

  // Public routes with tab bar (accessible without authentication, for sharing/SEO)
  publicWithTabsRoute.addChildren([
    restaurantRoute,
    listDetailsRoute,
    profileUserRoute,
  ]),

  // Onboarding routes (authenticated, no onboarding guard - prevents infinite loops)
  // Flow order: permissions → profile → friends → quiz → tour
  onboardingRoute.addChildren([
    onboardingPermissionsRoute,
    onboardingProfileRoute,
    onboardingFriendsRoute,
    onboardingQuizRoute,
  ]),

  // Authenticated routes (require login, have tab bar, have onboarding guard)
  authenticatedRoute.addChildren([
    dashboardRoute,
    digestArchiveRoute,
    pastIssueRoute,
    feedRoute,
    searchRoute,
    menuRoute,
    historyRoute,
    notificationsRoute,
    friendsRoute,
    friendsUserRoute,
    blockedUsersRoute,
    reportsRoute,
    settingsRoute,
    notificationSettingsRoute,
    subscriptionSettingsRoute,
    appearanceSettingsRoute,
    quizzesIndexRoute,
    quizRoute,
    profileIndexRoute,
    profileEditRoute,
    listsIndexRoute,
    collaborativeListDetailsRoute,
    postRoute,
    syncContactsRoute,
    quickSearchRoute,
  ]),
])
